module.exports = __webpack_public_path__ + "static/img/90-1.26f1833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/90-1.jpg
// module id = pS8F
// module chunks = 0